import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import { Home, Settings, ExitToApp, ReceiptLong, People as PeopleIcon } from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MenuIcon from '@mui/icons-material/Menu';
import SecurityIcon from '@mui/icons-material/Security';
import ApartmentIcon from '@mui/icons-material/Apartment';

const MenuComponent = ({ onLogout }) => {
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const menuItems = [
        { text: 'Home', icon: <Home />, onClick: () => navigate('/') },
        { text: 'Fatture', icon: <ReceiptLong />, onClick: () => navigate('/fatture') },
        { text: 'Clienti', icon: <PeopleIcon />, onClick: () => navigate('/clienti') },
        { text: 'Contratti', icon: <AssignmentIcon />, onClick: () => navigate('/contratti') },
        { text: 'Siti', icon: <ApartmentIcon />, onClick: () => navigate('/siti') },
        { text: 'Schede', icon: <AssignmentIcon />, onClick: () => navigate('/schede') },

    ];

    return (
        <>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={toggleDrawer(true)}
                sx={{ marginRight: 2 }}
            >
                <MenuIcon />
            </IconButton>
            <SecurityIcon sx={{ marginRight: 2 }} />
            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                sx={{ width: 240, flexShrink: 0, '& .MuiDrawer-paper': { width: 240, boxSizing: 'border-box' } }}
            >
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <List>
                        {menuItems.map((item, index) => (
                            <ListItem button key={item.text} onClick={item.onClick}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default MenuComponent;
